import './LoadingSpinner.scss';
import React from 'react';
import { string } from 'prop-types';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';

const LoadingSpinner = ({ name }) => {
  const message = `Loading ${name}`;
  return (
    <div className="page-loading-component-overlay">
      <p className="page-loading-message">{message}</p>
      <Spinner/>
    </div>
  );
};

LoadingSpinner.propTypes = {
  name: string.isRequired,
}

export default LoadingSpinner
